<template>
  <v-container id="contratos-jugador" fluid tag="section">
    <v-row justify="end" class="mb-3">
      <v-btn v-if="$can('M_viaticos')" color="#ac8a2e" icon @click="goToViaticoForm('new', 0)">
        <v-icon large>
          mdi-plus-box-multiple
        </v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-expansion-panels multiple>
        <v-expansion-panel v-for="(item,i) in tablas" :key="i">
          <v-expansion-panel-header>
            {{ item.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <viaticos-tabla :url="item.url" :mode="item.mode" :title="item.title" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import ViaticosTabla from '../pages/components/ViaticosTabla'

  export default {
    components: {
      ViaticosTabla,
    },
    props: {
    },
    data () {
      return {
        tablas: [
          { title: 'Viáticos Pendientes', url: '/api/solicitudes_extraordinarias_pendientes', mode: 'pendientes' },
          { title: 'Viáticos Cerrados', url: '/api/solicitudes_extraordinarias_cerradas', mode: 'cerrados' },
        ],
      }
    },
    created () {
    },
    methods: {
      goToViaticoForm (modeVal, viaticoId) {
        this.$router.push({ name: 'Alta viaticos', params: { mode: modeVal, id: viaticoId } })
      },
    },
  }
</script>
